import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './DidYouMean.styles';
var PROP_TYPES = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    latitude: PropTypes.string,
    longitude: PropTypes.string,
    suggestion: PropTypes.string
  })),
  selectStore: PropTypes.func
};
var DEFAULT_PROPS = {
  locations: []
};

var DidYouMean = function DidYouMean(_ref) {
  var locations = _ref.locations,
      selectStore = _ref.selectStore;
  return /*#__PURE__*/React.createElement(Styled.DidYouMeanContainer, null, /*#__PURE__*/React.createElement(Styled.DidYouMeanTitle, {
    tabIndex: "0"
  }, "Did you mean?"), /*#__PURE__*/React.createElement(Styled.DidYouMeanResults, null, locations.map(function (location, index) {
    return /*#__PURE__*/React.createElement(Styled.DidYouMeanResult, {
      key: location.suggestion,
      index: index
    }, /*#__PURE__*/React.createElement(Styled.DidYouMeanLocation, {
      onClick: function onClick(event) {
        return selectStore(event, "".concat(location.latitude, ",").concat(location.longitude));
      },
      kind: "secondary"
    }, location.suggestion));
  })));
};

DidYouMean.propTypes = PROP_TYPES;
DidYouMean.defaultProps = DEFAULT_PROPS;
export default DidYouMean;